import React, { useEffect } from 'react';

import { usePageContext } from '@/context/pageContext/Page.context.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import { GeneralError } from '@/views/generalError/GeneralError.view.tsx';

export const Forbidden: React.FC = () => {
  const { t } = useTranslationWithPrefix('generalError.forbidden');
  const { setPageDetails } = usePageContext();
  useEffect(() => {
    setPageDetails({
      titleId: 'knowMe',
    });
  }, []);

  return <GeneralError message={t('message')} subMessage={t('subMessage')} />;
};
